import React, { useEffect, useState, useRef, ReactNode } from "react";
import RenderSvg from "../renderSvg/RenderSvg";
import "./TextSwitcher.css"
export interface TextSwitcherItemObject{
    label?: string;
    text: string;
    svgIcon?: string;
    itemStyles?: {
        container?: React.CSSProperties;
        label?: React.CSSProperties;
        text?: React.CSSProperties;
        svg?: React.CSSProperties;
    };
    actionButton?: ReactNode;
}

interface TextSwitcherProps {
  textSwitcherItems: TextSwitcherItemObject[];
  interval?: number; // in ms
}

const TextSwitcher: React.FC<TextSwitcherProps> = ({
  textSwitcherItems,
  interval = 3000,
}) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (index >= textSwitcherItems.length) {
      setIndex(0); // reset to first item if array shrank
    }
  }, [textSwitcherItems, index]);
  useEffect(() => {
    if (!paused && textSwitcherItems.length > 1) {
      intervalRef.current = setInterval(() => {
        setIndex((prev) => (prev + 1) % textSwitcherItems.length);
      }, interval);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [paused, interval, textSwitcherItems.length]);

  return (
    <div
      className="text-switcher-container"
    >
      { textSwitcherItems.map((item, i) => {
        const isActive = i === index;
        return (
        <div
            key={i}
            className="text-switcher-item"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            style={{
                opacity: isActive ? 1 : 0,
              ...item.itemStyles?.container,
              pointerEvents: isActive ? "auto" : "none",
            }}
        >
            {item.svgIcon && <RenderSvg name={item.svgIcon} customStyles={item.itemStyles?.svg}/>}
            {item.label && <span style={item.itemStyles?.label}>{item.label}</span>}
            <span style={item.itemStyles?.text}>{item.text}</span>
            {item.actionButton}
        </div>
        );
    })}
    </div>
  );
};

export default TextSwitcher;
